jQuery(function () {
  const media = window.matchMedia('(max-width: 767px)');
  function updatePlaceholders() {
    document.querySelectorAll('section.contact-v2 .whatsapp-form').forEach(form => {
      form.querySelector('[name="name"]').placeholder = media.matches ? 'Tulis nama lengkap Anda' : 'Tulis nama lengkap';
      form.querySelector('[name="whatsapp_number"]').placeholder = media.matches ? 'Contoh: 08123456789' : 'Nomor WhatsApp';
    });
  }
  updatePlaceholders();
  if (media.addEventListener) {
    media.addEventListener('change', updatePlaceholders);
  } else {
    media.addListener(updatePlaceholders);
  }
});



// WEBPACK FOOTER //
// ./scripts/page-template/page-builder/contact-v2.js